export const QUESTIONS_GENERAL_ERROR =
  'Please answer all the questions before continuing.';
